var _style, _g, _path, _defs, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookmarkBlanko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Bookmark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.7 113.4",
    style: {
      enableBackground: "new 0 0 141.7 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#90C6EB;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000094581354349961629250000015763287084516242842_);fill:none;stroke:#873060;stroke-width:2.5;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#D60B52;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.5,105.4H16.2c-4.8,0-8.7-3.9-8.7-8.7v-80c0-4.8,3.9-8.7,8.7-8.7h109.3c4.8,0,8.7,3.9,8.7,8.7v80 C134.2,101.5,130.3,105.4,125.5,105.4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.4,105.4c0.1-0.9,0.1-1.8,0.2-2.5c0.2-3.6,0.3-7.2,0.4-10.9c0.2-6.1,0.3-12.2,0.5-18.3 c0.1-5-0.4-10.8-8.2-14c-5.5-2.2-13.1-2.4-20.1-2.6c-23.2-0.4-46.6-0.8-69.7,0.5c-2.1,0.1-4.3,0.3-6,0.9c-2.8,0.9-3.9,2.8-4.5,4.5 c-2.2,5.8-2.3,11.7-2.5,17.6c-0.2,8.3-0.2,16.6-0.1,24.9H125.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M125.5,105.4H16.2c-4.8,0-8.7-3.9-8.7-8.7v-80c0-4.8,3.9-8.7,8.7-8.7h109.3c4.8,0,8.7,3.9,8.7,8.7v80 C134.2,101.5,130.3,105.4,125.5,105.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000124143173118283528490000018074097872969632150_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000124143173118283528490000018074097872969632150_)",
      fill: "none",
      stroke: "#873060",
      strokeWidth: 2.5,
      strokeMiterlimit: 10
    },
    d: " M99.4,65h8.1c6.4,0,11.6,5.2,11.6,11.6v69.2c0,6.4-5.2,11.6-11.6,11.6H3.9c-6.4,0-11.6-5.2-11.6-11.6V76.7 C-7.7,70.2-2.5,65,3.9,65h71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.7,37.8c0-0.4,0-0.8-0.2-1.1c-0.4-0.4-1-0.4-1.6-0.4c-7.1,0-14.3,0-21.4,0c-0.8,0-1.6,0-2.3,0.4 c-0.7,0.4-1,1.2-1.3,2c-2.9,9.4-2.2,19.3-1.4,29.1c0.5,6.5,1,13.1,1.5,19.6c0.1,1.1,0.6,2.7,1.9,2.6c0.5,0,1-0.3,1.4-0.6 c4.4-3,7.8-6.6,11.4-10.3c3,1.8,8,9.4,8,9.4c5.7-0.8,3.4-10.6,3.4-14.2C95.8,62.1,96,50,96.7,37.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94,36.3h-1.9h-9.9h-1.9c-5.3,0-5.3,5.5-5.3,8.4v9.1v25.2c0,2.9,1.4,3.4,3,0.9l6.2-9.2 c0.6-0.9,1.4-1.5,2.2-1.7c0.3-0.1,0.5-0.1,0.8-0.1c0.1,0,0.3,0,0.4,0c0.9,0.1,1.9,0.7,2.6,1.8l6.2,9.2c1.7,2.4,3,2,3-0.9V53.8v-9.1 C99.4,41.8,99.4,36.3,94,36.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkBlanko);
export default __webpack_public_path__ + "static/media/Icon_Bookmark_blanko.e556d2a41262d6afd52a50cc0c2231e1.svg";
export { ForwardRef as ReactComponent };